import { Paper } from "@mui/material";
import "./CustomContainer.scss";

const CustomContainer = ({ children }) => {
  return (
    <Paper elevation={0} className="container">
      {children}
    </Paper>
  );
};

export default CustomContainer;
